import React from "react";

const EmojiSectionSkeleton: React.FC = () => {
  return (
    <div>
      <section className="liner-slider relative bg-[url('@assets/images/Home-emoji-BG.webp')] bg-no-repeat bg-100 bg-center max-xl:bg-left">
        <div className="py-12 border-t-8 border-b-8 border-secondary relative bg-cover bg-no-repeat bg-[url('@assets/images/BokehBlueBG.webp')] z-[1] before:absolute before:w-full before:h-full before:top-0 before:left-0 before:bg-black/20 before:-z-[1] min-h-[280px] flex items-center">
          <div className="container px-8 max-sm:px-4">
            <div className="grid grid-cols-3 max-lg:grid-cols-1 gap-6 items-center">
              <div className="col-span-2 flex overflow-hidden">
                {[1, 2, 3, 4, 5, 6].map((items, index) => (
                  <div
                    key={index}
                    className="relative h-36 w-36 max-md:w-28 max-md:h-28 max-sm:w-24 max-sm:h-24 mx-4 max-md:mx-2 bg-gray-300 skeleton rounded-2xl flex-shrink-0"
                  ></div>
                ))}
              </div>
              <div className="flex flex-col items-end gap-4">
                <span className="block bg-gray-300 skeleton w-[260px] max-md:w-[200px] h-12 rounded-lg"></span>
                <span className="block bg-gray-300 skeleton w-[340px] max-md:w-[260px] h-12 rounded-lg"></span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default EmojiSectionSkeleton;
